const getters = {
    isLogged: state => {
        return state.logged
    },

    getPermissions: state => {
        return state.permissions
    },

    getHeaderVisibility: state => {
        return state.headerVisibility
    },

    getOverlayVisibility: state => {
        return state.overlayVisibility
    },

    getDepositOverlayVisibility:state => {
        return state.depositOverlayVisibility
    },

    getOverlayContent: state => {
        return state.overlayContent
    },

    getDepositOverlayContent: state => {
        return state.depositOverlayContent
    },

    getCartContent: state => {
        return state.cartContentCounter
    },

    getCartContentVisibility: state => {
        return state.cartContentVisibility
    },

    getScannerVisibility: state => {
        return state.scannerVisibility
    },

    getUserId: state => {
        return state.userId
    },

    getLastWatched: state => {
        return state.lastWatched
    },

    getWatchList: state => {
        return state.watchlist
    },

    drawerVisibility: state => {
        return state.drawerVisibility
    },

    getCartContents: state => {
        return state.cartContents
    },

    getTotalPrice: state => {
        return state.totalPrice
    },

    getLoadingState: state => {
        return state.isLoading
    },

    getCategoryBreadcrumbs: state => {
        //return state.categoryBreadcrumbs[state.categoryBreadcrumbs.length-1]
        return state.categoryBreadcrumbs
    },

    getSideDrawerState: state => {
        return state.sideDrawerState
    },

    getCartDrawerState: state => {
        return state.cartDrawerState
    },

    getUserRole: state => {
        return state.userRole
    },

    getFirstName: state => {
        return state.user.firstNames
    },

    getBarcodeScannerState: state => {
        return state.barcodeScannerState
    },

    getDepositCollector: state => {
        return state.depositCollector
    },

    getDepositOverview: state => {
        return state.depositOverview
    },

    getShowNotification: state => {
        return state.showNotification
    },

    getNotificationTxt: state => {
        return state.notificationTxt
    },

    getCategories: state => {
        return state.categories
    },

    getCurrentCategory: state => {
        return state.currentCategory
    },

    getSignaturePadState: state => {
        return state.signaturePadState
    },

    getSignatureSVG: state => {
        return state.signatureSVG
    },

    getRestrictions: state => {
        return state.restrictions
    },

    getOrder: state => {
        return state.order
    },

    getDeliveryDays: state => {
        return state.allowedDates
    },

    getTopScroll: state => {
        return state.topScroll
    },

    newsAvailable: state => {
        return state.newsAvailable
    },
    getExcludePartialItems: state => {
        return state.excludePartialItems
    },
    getCurrentActiveMode: state => {
        return state.currentActiveMode
    }
}

export default getters
